import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "align-middle-h",
  "use": "align-middle-h-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"align-middle-h\"><g clip-path=\"url(#align-middle-h_clip0)\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 13V3M15 8h-4M6 8H1M12 10l-2-2 2-2M4 6l2 2-2 2\" /></g><defs><clipPath id=\"align-middle-h_clip0\"><path d=\"M16 0v16H0V0h16z\" fill=\"#fff\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol